/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React from 'react';

import { useAlignCenterStyles } from './AlignCenter.styles';

export function AlignCenter({ children, className }: { children: React.ReactNode; className?: string }) {
  const classes = useAlignCenterStyles();
  return <div className={cx(classes.root, className)}>{children}</div>;
}
